var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"decode-result"},[_vm._v(" 扫描结果: "),_c('b',[_vm._v(_vm._s(_vm.result))])]),_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }